export enum CookieConsentValue {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export const cookieConsent = 'cookieconsent'
